import { Col, Row, Button, Drawer, Input, Tooltip, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import navLogo from "../../../assets/ui/Logo SVG.svg";
import SidemenuMobile from "../../Sidemenu/SidemenuMobile";
import Recentprompttable from "../Desktop/Recentprompttable"
import Recentpromptmobiletable from "../Mobile/Recentpromptmobiletable";
import Navbarmobile from "../../Header/Mobile/Navbarmobile";
const RecentPromptsMobile = () => {
    const { agentname } = useSelector((state) => state.chat);
    return (
        <>
            {/* <Row className="chat-header-part">
                <Col className="chat-header-logo-title"> Recent Prompts</Col>
                <Col>
                    <img
                        src={navLogo}
                        alt="nav-logo "
                        className="navlogo cursor-pointer"
                    />
                </Col>
            </Row> */}
            <Row>
                <Col span={24}>
                    <Navbarmobile /></Col>
            </Row>
            <Row className="mobile-background">
                <Col span={24} className="white-color aivolvex-font d-flex justify-content-center p-1">
                    <h4>{agentname}</h4>
                </Col>
            </Row>
            <Row className="recent-mobile-body mobile-background">
                <Col span={24}>
                    {/* <Recentpromptmobiletable /> */}
                    <Recentprompttable/>
                </Col>
            </Row>
            <Row className="chat-bottom-section">
                <Col span={24} ><SidemenuMobile /></Col>
            </Row>
        </>
    )
}
export default RecentPromptsMobile;